/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useTranslations, useStyles } from "examsbook-react-sdk/custom-hooks";
import TabContainer from "./TabContainer";
import { pdfjs } from "react-pdf";
import SelfLearningContent from './SelfLearningContent/SelfLearningContent';
import { ReactComponent as EvaluationNoTest } from "../../assets/images/evaluation-No-Test.svg";
import "./SelfLearning.scss";
import InstructionBlock from '../Quiz/InstructionBlock/InstructionBlock';
import LearningText from '../SelfLearningText/LearningText';
import { useDispatch, useSelector } from 'react-redux';
import { courseCertificateListAction } from 'examsbook-react-sdk/actions/certificateAddResponse';
import moment from 'moment';
import { Viewer, Worker } from'@react-pdf-viewer/core';
import'@react-pdf-viewer/core/lib/styles/index.css';
import { setContentId, setUnlockCertificate } from 'examsbook-react-sdk/actions/getSelfLearningAction';
import LockIcon from '@material-ui/icons/Lock';
import { Box } from '@material-ui/core';


/**
 * Course Material Container.
 * @param props
 * @returns {*}
 * @constructor
 */

function TabsLandingPage(props) {
    const {
        selectedIndex,
        tabBarList,
        selectedTab,
        handleTabChange,
        onQuizCardClick,
        onPdfOpen,
        setdownloadCertificateButton,
        course_id,
        subject_id,
        topic_id,
        downloadCertificateButton,
        onVideoRefresh,
        videoRefresh,
        setSectionChanged,
        quizAttemptForResult,
        quizAttempCourseId,
        coursePercentage,
        pdfOpen,
        videoProgress,
        handleVideoProgress,
        item,
        showEvaluationTest,
        setShowEvaluationTest,
        courseName,
        courseDescription,
        isSelfLearning,
        isLive,
        selectedQuizCard,
        setSectionNumber,
        setSectionName,
        setNextClick,
        setIsDropDown,
        setCourseDataList,
        pdfPath,
        handleUpdateCourseProgress,
        selectedSubmenu,
        setSelectedSubmenu,
        currentSectionIndex,
        setCurrentSectionIndex,
        currentDataIndex,
        setCurrentDataIndex,
        setIsDropdownOpen,
        isDropdownOpen,
        mySectionData,
        setMySectionData,
        openPdfViewer,
        setSubmittedTest,
        setIsPracticeQuizModal,
        setPracticeQuizData,
        setShowCourseModalAfterQuiz,
        setSuppressCourseModal
    } = props;
    const isCourseExpired = props.isCourseExpired;
    const neverExpired = props.neverExpired;
    const t = useTranslations();
    const dispatch = useDispatch();
    const classes = useStyles(styles)();
    const [showComponent, setShowComponent] = useState(false);
    const [quizIsStarted, setQuizStarted] = useState(false);
    const [showInstructionBox, setInstructionBox] = useState(true);
    const [certificateData, setCertificateData] = useState([])
    const contentId = useSelector(state => state.selfLearningReducers.contentId);

    useEffect(() => {
        if (item?.contentId && (item?.contentId!==null || item?.contentId!==undefined)) {
          dispatch(setContentId(item?.contentId));
        }
      }, [item?.contentId, dispatch, contentId]);

    const getCourseSectionData = async () => {
        try {
          if (course_id !== undefined) {
            if (!props.activeItem && typeof mySectionData != "undefined") {
                props.setActiveItem({
                    data:mySectionData?.data?.section[0],
                    sectionData:mySectionData?.data
                });
            }
          }
        } catch (error) {
            console.error(error.message);
        }
    };
    useEffect(() => {
        getCourseSectionData();
    }, [course_id]);

    useEffect(() => { pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`; });

    useEffect(() => {
        const handleContextmenu = e => {
            e.preventDefault()
        }
        document.addEventListener('contextmenu', handleContextmenu)
        return function cleanup() {
            document.removeEventListener('contextmenu', handleContextmenu)
        }
    }, [])


    if(mySectionData && mySectionData?.data?.evaluationTest && mySectionData?.data?.evaluationTest?.length > 0) {
        var quizEndDate = moment(mySectionData?.data?.evaluationTest[0]?.testId?.endDate).format("DD-MM-YYYY HH:mm:ss");
    }
    function toggleInstructionBox() {
        setInstructionBox(!showInstructionBox);
    }

    async function startQuiz() {
        await getCourseSectionData();
        setQuizStarted(true);
        setInstructionBox(false);
        props.setStartButtonClicked(true);
    }
    useEffect(() => {
        const timer = setTimeout(() => {
            setShowComponent(true);
        }, 3000);

        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        if (course_id) {
            dispatch(courseCertificateListAction(course_id)).then((res) => {
                if (res?.data?.length) {
                    setCertificateData(res?.data[0])
                    dispatch(setUnlockCertificate(res?.data?.[0]?.isCompleted))
                }
            });
        }
    }, [course_id]);
    const checkEvaluationUnlockPercent = (quizData) => {
        return quizData?.EvaluationUnlockPercent
    }

    const checkUnlockEvaluationTest = (quizData) => {
        if (Math.round(coursePercentage) >= quizData?.EvaluationUnlockPercent) {
            return true;
        } else {
            return false;
        }
    }

    return (
        <>
            {/* {selectedIndex === 0 && */}
            {
                <TabContainer className={classes.contentBox}>
                    {showEvaluationTest ?
                        item?.refModel === "RecordedVideo" ?
                            <TabContainer className={classes.contentBox}>
                                <SelfLearningContent
                                    videoProgress={videoProgress}
                                    mySectionData={mySectionData}
                                    setMySectionData={setMySectionData}
                                    handleVideoProgress={handleVideoProgress}
                                    activeItem={item}
                                    selectedCourseId={course_id}
                                    pdfOpen={pdfOpen}
                                    openPdfViewer={openPdfViewer}
                                    videoRefresh={videoRefresh}
                                    onVideoRefresh={onVideoRefresh}
                                    certificateUnlocked={certificateData?.isCompleted}
                                    showEvaluationTest={showEvaluationTest}
                                    setShowEvaluationTest={setShowEvaluationTest}
                                    courseName={courseName}
                                    courseDescription={courseDescription}
                                    isSelfLearning={isSelfLearning}
                                    isLive={isLive}
                                    startQuiz={startQuiz}
                                    showInstructions={props?.showInstructions}
                                    showInstructionScreen={props?.showInstructionScreen}
                                    subjectDetail={props?.subjectDetail}
                                    sectionName={props?.sectionName}
                                    sectionId={props?.activeItem?.data?._id}
                                    handleUpdateCourseProgress={handleUpdateCourseProgress}
                                    setSectionNumber={setSectionNumber}
                                    setSectionName={setSectionName}
                                    setNextClick={setNextClick}
                                    setIsDropDown={setIsDropDown}
                                    setCourseDataList={setCourseDataList}
                                    selectedSubmenu={selectedSubmenu}
                                    setSelectedSubmenu={setSelectedSubmenu}
                                    currentSectionIndex = {currentSectionIndex}
                                    setCurrentSectionIndex = {setCurrentSectionIndex}
                                    currentDataIndex = {currentDataIndex}
                                    setCurrentDataIndex={setCurrentDataIndex}
                                    isDropdownOpen={isDropdownOpen}
                                    setIsDropdownOpen={setIsDropdownOpen}
                                    setSubmittedTest={setSubmittedTest}
                                    setShowCourseModalAfterQuiz={setShowCourseModalAfterQuiz}
                                    coursePercentage={coursePercentage}
                                    setSuppressCourseModal={setSuppressCourseModal}
                                    isCourseExpired={isCourseExpired}
                                    neverExpired={neverExpired}
                                />
                            </TabContainer>
                            : item?.refModel === "TextNotes" ?
                            <TabContainer className={classes.contentBox}>
                          <LearningText
                            textData={item?.contentData}
                            textName={item?.name}
                            courseId={course_id}
                            moduleId={item?.contentId}
                            sectionId={props?.activeItem?.data?._id}
                            showAssignmentUpload={false}
                          />
                            </TabContainer>
                            : item?.refModel === "Assignments" ? (() => {
                                // Find the section that contains this assignment
                                let moduleSectionId = props?.activeItem?.data?._id;
                                if (mySectionData?.data?.section) {
                                    for (const section of mySectionData.data.section) {
                                        if (section.courseSectionData?.some(data => data._id === item?._id)) {
                                            moduleSectionId = section._id;
                                            break;
                                        }
                                    }
                                }
                                return isCourseExpired ? (
                            <TabContainer className={classes.contentBox}>
                              <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 20px', opacity: 0.6 }}>
                                <LockIcon style={{ fontSize: '48px', color: '#9e9e9e', marginBottom: '12px' }} />
                                <span style={{ fontSize: '16px', fontWeight: 500, color: '#616161', textAlign: 'center' }}>{t('This course has expired. Assignment is no longer accessible.')}</span>
                              </Box>
                            </TabContainer>
                                ) : (
                            <TabContainer className={classes.contentBox}>
                          <LearningText
                            key={item?._id}
                            textData={item?.contentData}
                            textName={item?.name}
                            courseId={course_id}
                            sectionId={moduleSectionId}
                            courseSectionDataId={item?._id}
                            showAssignmentUpload={true}
                            onAssignmentApproved={handleUpdateCourseProgress}
                            courseIdForProgress={course_id}
                            onVideoRefresh={onVideoRefresh}
                            videoRefresh={videoRefresh}
                          />
                            </TabContainer>
                                );
                            })()
                            : item?.refModel === "Quiz" ?
                                <TabContainer className={classes.contentBox}>
                                    {!item?.contentData && showComponent &&
                                        <div className={classes.divcertificate}>
                                            <EvaluationNoTest className={classes.imgAlign} />
                                            <p className={classes.textHeading}>{t('No Test Found!')}</p>
                                            <p className={classes.textPara}>{t('Apologies, but there are currently no evaluation')}<br />{t('tests available for display.')}</p>
                                        </div>
                                    }

                                    {item?.contentData && <InstructionBlock 
                                        key={item?.contentData?._id || item?.contentData?.id || JSON.stringify(item?.contentData)}
                                        quiz={item?.contentData}
                                        quizIsStarted={quizIsStarted}
                                        toggleInstructionBox={toggleInstructionBox}
                                        startQuiz={startQuiz}
                                        contentId={item?.contentId || contentId}
                                        quizAttemptForResult={quizAttemptForResult}
                                        quizAttempCourseId={quizAttempCourseId}
                                        unlockEvaluationTest={checkUnlockEvaluationTest(item?.contentData)}
                                        evaluationUnlockPercentage={checkEvaluationUnlockPercent(item?.contentData)}
                                        certificateUnlocked={certificateData?.isCompleted}
                                        quizEndDate={quizEndDate}
                                        startButtonClicked={props.startButtonClicked}
                                        selectedQuizCard={item?.contentData}
                                        courseName={courseName}
                                        course_id={course_id}
                                        sectionId={props?.activeItem?.data?._id}
                                        mySectionData={mySectionData}
                                        setMySectionData={setMySectionData}
                                        setSubmittedTest={setSubmittedTest}
                                        setIsPracticeQuizModal={setIsPracticeQuizModal}
                                        setPracticeQuizData={setPracticeQuizData}
                                        setShowCourseModalAfterQuiz={setShowCourseModalAfterQuiz}
                                        coursePercentage={coursePercentage}
                                        setSuppressCourseModal={setSuppressCourseModal}
                                        isCourseExpired={isCourseExpired}
                                        neverExpired={neverExpired}
                                    />}
                                </TabContainer>
                                : item?.refModel === "Questions" ?
                                <TabContainer className={classes.contentBox}>
                                    {item?.contentData && <InstructionBlock 
                                        key={item?.contentData?._id || item?.contentData?.id || JSON.stringify(item?.contentData)}
                                        quiz={item?.contentData}
                                        courseName={item?.name}
                                        contentId={item?.contentId || contentId}
                                        mySectionData={mySectionData}
                                        setMySectionData={setMySectionData}
                                        handleUpdateCourseProgress={handleUpdateCourseProgress}
                                        course_id={course_id}
                                        sectionId={props?.activeItem?.data?._id}
                                        setSubmittedTest={setSubmittedTest}
                                        setIsPracticeQuizModal={setIsPracticeQuizModal}
                                        setPracticeQuizData={setPracticeQuizData}
                                        setShowCourseModalAfterQuiz={setShowCourseModalAfterQuiz}
                                        coursePercentage={coursePercentage}
                                        setSuppressCourseModal={setSuppressCourseModal}
                                        isCourseExpired={isCourseExpired}
                                        neverExpired={neverExpired}
                                    />}
                                </TabContainer>
                                : item?.refModel === "PdfNotes" ?(
                                    pdfPath ? (
                                        <div className={classes.pdfContainer}>
                                            <Worker workerUrl={`https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`}>
                                                <Viewer fileUrl={pdfPath} />
                                            </Worker>
                                        </div>
                                    ) : ( <>{t("Failed_to_load_pdf_file")}</> ))
                                    : <></>

                        : props.showInstructions ?
                            <InstructionBlock 
                                key={mySectionData?.data?.evaluationTest[0]?.testId?._id || mySectionData?.data?.evaluationTest[0]?.testId?.id || JSON.stringify(mySectionData?.data?.evaluationTest[0]?.testId)}
                                quiz={mySectionData?.data?.evaluationTest[0]?.testId}
                                quizIsStarted={quizIsStarted}
                                toggleInstructionBox={toggleInstructionBox}
                                startQuiz={startQuiz}
                                mySectionData={mySectionData}
                                setMySectionData={setMySectionData}
                                quizAttemptForResult={quizAttemptForResult}
                                quizAttempCourseId={quizAttempCourseId}
                                unlockEvaluationTest={checkUnlockEvaluationTest(mySectionData?.data?.evaluationTest[0]?.testId)}
                                evaluationUnlockPercentage={checkEvaluationUnlockPercent(mySectionData?.data?.evaluationTest[0]?.testId)}
                                certificateUnlocked={certificateData?.isCompleted}
                                quizEndDate={quizEndDate}
                                startButtonClicked={props.startButtonClicked}
                                selectedQuizCard={mySectionData}
                                courseName={courseName}
                                course_id={course_id}
                                contentId={item?.contentId}
                                sectionId={props?.activeItem?.data?._id}
                                setSubmittedTest={setSubmittedTest}
                                setIsPracticeQuizModal={setIsPracticeQuizModal}
                                setPracticeQuizData={setPracticeQuizData}
                                setShowCourseModalAfterQuiz={setShowCourseModalAfterQuiz}
                                coursePercentage={coursePercentage}
                                setSuppressCourseModal={setSuppressCourseModal}
                                isCourseExpired={isCourseExpired}
                                neverExpired={neverExpired}
                            /> : <SelfLearningContent
                                selectedIndex={selectedIndex}
                                videoProgress={videoProgress}
                                mySectionData={mySectionData}
                                setMySectionData={setMySectionData}
                                handleVideoProgress={handleVideoProgress}
                                activeItem={props.activeItem}
                                setActiveItem={props.setActiveItem}
                                selectedCourseId={course_id}
                                openPdfViewer={openPdfViewer}
                                pdfOpen={pdfOpen}
                                videoRefresh={videoRefresh}
                                onVideoRefresh={onVideoRefresh}
                                certificateUnlocked={certificateData?.isCompleted}
                                coursePercentage={coursePercentage}
                                tabBarList={tabBarList}
                                onPdfOpen={onPdfOpen}
                                selectedTab={selectedTab}
                                subject_id={subject_id}
                                topic_id={topic_id}
                                handleTabChange={handleTabChange}
                                setSectionChanged={setSectionChanged}
                                onQuizCardClick={onQuizCardClick}
                                setSectionNumber={setSectionNumber}
                                setSectionName={setSectionName}
                                sectionId={props?.activeItem?.data?._id}
                                handleUpdateCourseProgress={handleUpdateCourseProgress}
                                setNextClick={setNextClick}
                                setIsDropDown={setIsDropDown}
                                setCourseDataList={setCourseDataList}
                                setdownloadCertificateButton={setdownloadCertificateButton}
                                downloadCertificateButton={downloadCertificateButton}
                                quizIsStarted={quizIsStarted}
                                toggleInstructionBox={toggleInstructionBox}
                                startQuiz={startQuiz}
                                quizAttemptForResult={quizAttemptForResult}
                                quizAttempCourseId={quizAttempCourseId}
                                unlockEvaluationTest={checkUnlockEvaluationTest(item?.contentData)}
                                evaluationUnlockPercentage={checkEvaluationUnlockPercent(item?.contentData)}
                                quizEndDate={quizEndDate}
                                startButtonClicked={props.startButtonClicked}
                                selectedQuizCard={selectedQuizCard}
                                showComponent={showComponent}
                                certificateData={certificateData}
                                showEvaluationTest={showEvaluationTest}
                                setShowEvaluationTest={setShowEvaluationTest}
                                courseName={courseName}
                                courseDescription={courseDescription}
                                isSelfLearning={isSelfLearning}
                                isLive={isLive}
                                showInstructions={props?.showInstructions}
                                showInstructionScreen={props?.showInstructionScreen}
                                subjectDetail={props?.subjectDetail}
                                sectionName={props?.sectionName}
                                selectedSubmenu={selectedSubmenu}
                                setSelectedSubmenu={setSelectedSubmenu}
                                currentSectionIndex = {currentSectionIndex}
                                setCurrentSectionIndex = {setCurrentSectionIndex}
                                currentDataIndex = {currentDataIndex}
                                setCurrentDataIndex={setCurrentDataIndex}
                                isDropdownOpen={isDropdownOpen}
                                setIsDropdownOpen={setIsDropdownOpen}
                                setSubmittedTest={setSubmittedTest}
                                setShowCourseModalAfterQuiz={setShowCourseModalAfterQuiz}
                                setSuppressCourseModal={setSuppressCourseModal}
                                isCourseExpired={isCourseExpired}
                                neverExpired={neverExpired}
                            />}
                </TabContainer>}
        </>
    );
}

const styles = {
    contentBox: {
        "& div": {
            "& div": {
                minHeight: '0px'
            }
        },
    },
    pdfContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    textPara: {
        fontWeight: '400',
        fontSize: '14px',
        color: '#84818A',
        textAlign: 'center',
        margin: '0px',
        '@media (max-width: 600px)': {
            fontSize: '11px',
        },
    },

    textHeading: {
        fontWeight: '700',
        fontSize: '32px',
        margin: '0px',
        '@media (max-width: 600px)': {
            fontSize: '20px'
        },
    },

    imgAlign: {
        marginTop: 'calc(10vh - 50px)',
        '@media (max-width: 425px)': {
            height: '17rem'
        },
        '@media (max-width:959px)': {
            height: '12.7rem'
        }
    },

    divcertificate: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '3rem'
    },
    '@media (max-width: 1024px)': {
        divcertificate: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0px'
        },
    },
}

export default TabsLandingPage;
